var Utils = require("common/Utils");
var AbstractDialog = require("common/AbstractDialog");

function PromptDialog() {
    AbstractDialog.call(this);
    var self = this;

    var $message = $('<div class="errorText">');
    var $buttonArea = $('<div data-role="footer">');
    var content = this.getContent();
    content.find("a").remove();
    content.attr("id", "promptDialog")
        .append($message)
        .append($buttonArea);

    this.configure = function(title, message, options) {
        this.setTitle(title);
        $message.text(message);

        var deferred = new $.Deferred();
        $buttonArea.empty();
        Object.keys(options).forEach(function(key) {
            var button = $("<button>", {text : options[key]});
            button.on("click", function() {
                deferred.resolveWith(self, [key]);
                content.popup("close");
            });
            $buttonArea.append(button);
        });

        $buttonArea.enhanceWithin();

        return deferred.promise();
    };

    this.setEnabled = function(val) {
        $buttonArea.find("button").each(function() {
            Utils.setElementEnabled($(this), val);
        });
    };
}

Utils.inherits(PromptDialog, AbstractDialog);

module.exports = PromptDialog;


//////////////////
// WEBPACK FOOTER
// ./common/PromptDialog.js
// module id = 22
// module chunks = 3 4